// Mock data for NexGen MMA Club

export const courses = [
  {
    id: 1,
    title: "Mixed Martial Arts",
    discipline: "MMA",
    description: "Complete combat system combining striking, grappling, and ground fighting techniques",
    levels: ["Beginners", "Intermediate", "Advanced"],
    ageGroups: "16+ years",
    benefits: [
      "Full-body conditioning",
      "Self-defense mastery",
      "Competition preparation",
      "Mental toughness"
    ],
    image: "https://images.unsplash.com/photo-1611077479643-5b3c01381f9e"
  },
  {
    id: 2,
    title: "Kickboxing",
    discipline: "Kickboxing",
    description: "High-intensity striking discipline combining punches and kicks for devastating power",
    levels: ["Beginners", "Intermediate", "Advanced"],
    ageGroups: "12+ years",
    benefits: [
      "Explosive striking power",
      "Cardiovascular endurance",
      "Weight loss & toning",
      "Stress relief"
    ],
    image: "https://images.unsplash.com/photo-1602668195478-2161aa8d1a0b"
  },
  {
    id: 3,
    title: "Brazilian Jiu-Jitsu",
    discipline: "BJJ",
    description: "Ground fighting art focusing on submission grappling and positional control",
    levels: ["Beginners", "Intermediate", "Advanced"],
    ageGroups: "10+ years",
    benefits: [
      "Technical grappling skills",
      "Problem-solving mindset",
      "Self-defense without striking",
      "Competition ready"
    ],
    image: "https://images.unsplash.com/photo-1564415315949-7a0c4c73aab4"
  },
  {
    id: 4,
    title: "Combat Fitness",
    discipline: "Combat Fitness",
    description: "High-intensity functional training combining combat conditioning with strength building",
    levels: ["Beginners", "Intermediate", "Advanced"],
    ageGroups: "16+ years",
    benefits: [
      "Peak physical conditioning",
      "Functional strength training",
      "Enhanced endurance",
      "Combat-ready fitness"
    ],
    image: "https://images.unsplash.com/photo-1541337082051-5959dbb57d5d"
  },
  {
    id: 5,
    title: "Karate",
    discipline: "Karate",
    description: "Traditional striking art emphasizing discipline, precision, and devastating techniques",
    levels: ["Beginners", "Intermediate", "Advanced"],
    ageGroups: "5+ years",
    benefits: [
      "Discipline & respect",
      "Precision striking",
      "Traditional values",
      "Youth development"
    ],
    image: "https://images.unsplash.com/photo-1555597673-b21d5c935865"
  },
  {
    id: 6,
    title: "Self Defense",
    discipline: "Self Defense",
    description: "Practical self-defense techniques for real-world situations focusing on awareness and protection",
    levels: ["Beginners", "Intermediate", "Advanced"],
    ageGroups: "10+ years",
    benefits: [
      "Real-world protection skills",
      "Situational awareness",
      "Confidence building",
      "Quick reaction training"
    ],
    image: "https://images.unsplash.com/photo-1644594570589-ef85bd03169f"
  }
];

export const schedule = [
  { day: "Monday", time: "7:00 AM - 8:00 AM", discipline: "Kickboxing", level: "All Levels", instructor: "Varun Gupta" },
  { day: "Monday", time: "8:00 AM - 9:00 AM", discipline: "Kickboxing", level: "All Levels", instructor: "Varun Gupta" },
  { day: "Monday", time: "5:00 PM - 6:00 PM", discipline: "Karate", level: "Kids", instructor: "Shushant Sharma" },
  { day: "Monday", time: "6:00 PM - 7:00 PM", discipline: "Kickboxing", level: "All Levels", instructor: "Kuldeep Tanwar" },
  { day: "Monday", time: "7:00 PM - 8:00 PM", discipline: "Kickboxing", level: "All Levels", instructor: "Kuldeep Tanwar" },
  { day: "Tuesday", time: "5:00 PM - 6:00 PM", discipline: "Karate", level: "Kids", instructor: "Shushant Sharma" },
  { day: "Tuesday", time: "6:00 PM - 7:00 PM", discipline: "MMA", level: "All Levels", instructor: "Shushant Sharma" },
  { day: "Tuesday", time: "7:00 PM - 8:00 PM", discipline: "MMA", level: "All Levels", instructor: "Shushant Sharma" },
  { day: "Wednesday", time: "7:00 AM - 8:00 AM", discipline: "BJJ", level: "All Levels", instructor: "Varun Gupta" },
  { day: "Wednesday", time: "8:00 AM - 9:00 AM", discipline: "BJJ", level: "All Levels", instructor: "Varun Gupta" },
  { day: "Wednesday", time: "5:00 PM - 6:00 PM", discipline: "Karate", level: "Kids", instructor: "Shushant Sharma" },
  { day: "Wednesday", time: "6:00 PM - 7:00 PM", discipline: "Combat Fitness", level: "All Levels", instructor: "Kuldeep Tanwar" },
  { day: "Wednesday", time: "7:00 PM - 8:00 PM", discipline: "BJJ", level: "All Levels", instructor: "Kuldeep Tanwar" },
  { day: "Thursday", time: "5:00 PM - 6:00 PM", discipline: "Karate", level: "Kids", instructor: "Shushant Sharma" },
  { day: "Thursday", time: "6:00 PM - 7:00 PM", discipline: "MMA", level: "All Levels", instructor: "Shushant Sharma" },
  { day: "Thursday", time: "7:00 PM - 8:00 PM", discipline: "BJJ", level: "All Levels", instructor: "Shushant Sharma" },
  { day: "Friday", time: "7:00 AM - 8:00 AM", discipline: "Kickboxing", level: "All Levels", instructor: "Varun Gupta" },
  { day: "Friday", time: "8:00 AM - 9:00 AM", discipline: "BJJ", level: "All Levels", instructor: "Varun Gupta" },
  { day: "Friday", time: "5:00 PM - 6:00 PM", discipline: "Karate", level: "Kids", instructor: "Shushant Sharma" },
  { day: "Friday", time: "6:00 PM - 7:00 PM", discipline: "Combat Fitness", level: "All Levels", instructor: "Kuldeep Tanwar" },
  { day: "Friday", time: "7:00 PM - 8:00 PM", discipline: "Kickboxing", level: "All Levels", instructor: "Kuldeep Tanwar" },
  { day: "Saturday", time: "5:00 PM - 6:00 PM", discipline: "Karate", level: "Kids", instructor: "Shushant Sharma" },
  { day: "Saturday", time: "6:00 PM - 7:00 PM", discipline: "MMA", level: "All Levels", instructor: "Shushant Sharma" },
  { day: "Saturday", time: "7:00 PM - 8:00 PM", discipline: "MMA", level: "All Levels", instructor: "Shushant Sharma" }
];

export const products = [
  {
    id: 1,
    name: "NexGen Fight Tee",
    category: "Shirts",
    price: "₹999",
    image: "https://images.unsplash.com/photo-1615117013933-67fafa955416",
    sizes: ["S", "M", "L", "XL", "XXL"]
  },
  {
    id: 2,
    name: "Premium Training Hoodie",
    category: "Hoodies",
    price: "₹2,499",
    image: "https://images.unsplash.com/photo-1716951187026-77811cc8c929",
    sizes: ["M", "L", "XL", "XXL"]
  },
  {
    id: 3,
    name: "Fight Shorts - Black",
    category: "Shorts",
    price: "₹1,499",
    image: "https://images.unsplash.com/photo-1734668487893-d686f3c8d0cf",
    sizes: ["S", "M", "L", "XL"]
  },
  {
    id: 4,
    name: "Training Gloves - Pro",
    category: "Gloves",
    price: "₹3,999",
    image: "https://images.unsplash.com/photo-1549719386-74dfcbf7dbed",
    sizes: ["10oz", "12oz", "14oz", "16oz"]
  },
  {
    id: 5,
    name: "Boxing Gloves - Red",
    category: "Gloves",
    price: "₹3,499",
    image: "https://images.unsplash.com/photo-1509255929945-586a420363cf",
    sizes: ["10oz", "12oz", "14oz", "16oz"]
  },
  {
    id: 6,
    name: "Training Pants",
    category: "Pants",
    price: "₹1,799",
    image: "https://images.unsplash.com/photo-1734668487893-d686f3c8d0cf",
    sizes: ["S", "M", "L", "XL", "XXL"]
  }
];

export const coaches = [
  {
    id: 1,
    name: "Shushant Sharma",
    title: "Head Coach",
    image: "https://customer-assets.emergentagent.com/job_fight-evolution-2/artifacts/ciynpzxg_Shushant.png"
  },
  {
    id: 2,
    name: "Varun Gupta",
    title: "Coach",
    image: "https://customer-assets.emergentagent.com/job_fight-evolution-2/artifacts/ykxre1kr_Varun.png"
  },
  {
    id: 3,
    name: "Kuldeep Tanwar",
    title: "Coach",
    image: "https://customer-assets.emergentagent.com/job_fight-evolution-2/artifacts/itz4edlj_Kuldeep.png"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Kavita Yadav",
    role: "Student - 3 years",
    text: "NexGen transformed me from a beginner to competing in National Kickboxing. The coaches are world-class and the community is incredible.",
    rating: 5
  },
  {
    id: 2,
    name: "Manu Sharma",
    role: "Kickboxing Member",
    text: "Best decision I ever made. Lost 30kg, gained confidence, and learned real Kickboxing. I represented Haryana state in wakoIndia National competition",
    rating: 5
  },
  {
    id: 3,
    name: "Anshika sharma",
    role: "BJJ Practitioner",
    text: "The technical instruction is top-tier. Coach Shushant's attention to detail is exceptional.",
    rating: 5
  }
];

export const instagramPosts = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1688141402330-f4ed03f6bbf9",
    caption: "Morning grind 💪 #NexGenMMA #Training",
    likes: 234,
    comments: 12
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1611077479643-5b3c01381f9e",
    caption: "Sparring session with the team 🥊",
    likes: 189,
    comments: 8
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1615117950029-db3cf44bdefa",
    caption: "BJJ fundamentals class 🥋",
    likes: 156,
    comments: 5
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1602668195478-2161aa8d1a0b",
    caption: "Kickboxing power! 🔥",
    likes: 201,
    comments: 15
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1541337082051-5959dbb57d5d",
    caption: "Wrestling takedowns 💯",
    likes: 178,
    comments: 9
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1555597673-b21d5c935865",
    caption: "Karate tradition meets modern training",
    likes: 143,
    comments: 6
  }
];

export const clubInfo = {
  name: "NexGen MMA Club",
  tagline: "Train Like a Fighter. Evolve Like NexGen.",
  mission: "To develop world-class martial artists through elite training, discipline, and community",
  vision: "Building the next generation of combat sports champions and empowering individuals through martial arts",
  philosophy: "We believe in the transformative power of martial arts. Beyond techniques, we build character, resilience, and champions for life.",
  location: "Sector 14, Gurugram, Haryana",
  phone: "7011161010",
  email: "dojo@nexgenmma.in",
  instagram: "https://www.instagram.com/nexgenmmaclub/",
  mapUrl: "https://maps.app.goo.gl/82RBKfvgW1fLyFvL6"
};
